import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'
import { PartialLayerSpec } from './template'

export default (
  layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification
): PartialLayerSpec[] => {
  const layerMin = Math.min(
    ...layerValues.map((lv) => lv.styleConfig.minValue ?? 0)
  )
  const layerMax = Math.max(
    ...layerValues.map((lv) => lv.styleConfig.maxValue ?? 0)
  )
  return [
    {
      id: 'raster',
      type: 'raster',
      paint: {
        'raster-color': mapboxColorExpression as ExpressionSpecification,
        'raster-resampling': 'nearest',
        'raster-color-range': [layerMin, layerMax]
      }
    }
  ]
}
